// messageValidation.ts
import DOMPurify from "dompurify";
// Accepts only whitelisted characters: letters, numbers, basic punctuation, spaces, and newlines
const WHITELIST_REGEX = /^[a-zA-Z0-9 .,!?'"()\-\n\r]+$/;

// Escapes HTML special characters
export function sanitizeInput(input, maxLength = 1000) {
  if (typeof input !== "string") return "";
  let trimmed = input.trim().slice(0, maxLength);
  // Only allow whitelisted characters
  if (!WHITELIST_REGEX.test(trimmed)) {
    // Remove all non-whitelisted characters
    trimmed = trimmed.replace(/[^a-zA-Z0-9 .,!?'"()\-\n\r]/g, "");
  }
  // Escape HTML entities
  return trimmed
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;")
    .replace(/\//g, "&#x2F;");
}

export const capitalizeFirstLetter = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};


export const validateMessageBody = (value, minLength, maxLength, t, skipLengthValidation=false) => {
  const trimmed = value.trim();
    // 3. Disallowed patterns (basic XSS payloads)
  const dangerousPatterns = [
    /<script.*?>.*?<\/script>/i,
    /javascript:/i,
    /on\w+=/i, // inline event handlers like onerror, onclick
  ];
  for (const pattern of dangerousPatterns) {
    const match = trimmed.match(pattern); 
    if (match) { 
      return { 
        title: t("ConnectInvalidCharacterErrorTitle"),
        error: t("ConnectInvalidCharacterErrorDescription", { invalidCharList: match[0] })
      };
    }
  }

  // 4. Blacklisted characters (custom rule)
  const blacklistedChars = ["<", ">", "{", "}", "`", "$"]; 
  let charList =[]
  for (const char of blacklistedChars) {
    if (trimmed.includes(char)) {
      charList.push(char);
    }
  }
      if(charList?.length> 0){
            return {
        title: t("ConnectInvalidCharacterErrorTitle"),
        error: t("ConnectInvalidCharacterErrorDescription", { invalidCharList: charList.join(",") })
      };
    }

  // 5. Sanitization check (optional defensive step)
  const sanitized = DOMPurify.sanitize(trimmed, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
  if (sanitized !== trimmed) {
    return {
      title: t("ConnectInvalidCharacterErrorTitle"),
      error: t("ConnectInvalidCharacterErrorDescription")
    };
  }
  // 1. Required check
  if (trimmed.length === 0) {
    return {
      title: t("FeedbackEmptyMessageErrorTitle"),
      error: t("FeedbackEmptyMessageErrorDescription")
    }
  }
  if(!skipLengthValidation) {
    // 2. Length caps (DoS prevention)
  if (trimmed.length < minLength) {
    return {
      title: t("ConnectMinCharacterErrorTitle"),
      error: t("ConnectMinCharacterErrorDescription", {minChar: minLength})
    }
  }
  if (trimmed.length > maxLength) {
    return {
      title: t("ConnectMaxCharacterErrorTitle"),
      error: t("ConnectMaxCharacterErrorDescription", {maxChar: maxLength})
    }
  }
  }
  // ✅ Passed all checks
  return {
    title: null,
    error: null
  };
};
